/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Image from 'next/image'
import styles from './noFastagFound.module.scss'
import { ERROR_IMG, NO_FASTAG_ERROR_ONE, NO_FASTAG_ERROR_TWO, NO_FASTAG_FOUND } from './constants'

const NoFastagFound = () => (
    <div>
      <h1 className={styles.noFastagHeading}>
        <Image className={styles.noFastagErrorImg} src={ERROR_IMG} alt="search" width={30} height={30} />
        {NO_FASTAG_FOUND}</h1>
      <span className={styles.noFastagPara}>{NO_FASTAG_ERROR_ONE}</span>
      <span className={styles.noFastagPara}>{NO_FASTAG_ERROR_TWO}</span>
    </div>
  )

export default NoFastagFound
